import React, { useState } from 'react';
import './Contact.css';
import ParticleCanvas from './ParticleCanvas';

export default function Contact({ t }) {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const onChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      setSent(true);
    } catch {
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="contact">
      <ParticleCanvas preset="ash" />
      <div className="contact-inner">
        <h2 className="section-title">{t.title}</h2>
        <p className="section-subtitle">{t.subtitle}</p>

        <div className="contact-book">
          <h3 className="contact-book-title">{t.bookTitle}</h3>
          <p className="contact-book-body">{t.bookBody}</p>
          <a href={t.bookUrl} target="_blank" rel="noopener noreferrer" className="contact-book-btn">
            {t.bookCta}
          </a>
        </div>

        {sent ? (
          <div className="contact-success">
            <span className="contact-success-icon">✦</span>
            <p>Your message has been received.</p>
          </div>
        ) : (
          <form className="contact-form" onSubmit={onSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>{t.name}</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={onChange}
                  required
                  autoComplete="off"
                />
              </div>
              <div className="form-group">
                <label>{t.email}</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={onChange}
                  required
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="form-group">
              <label>{t.message}</label>
              <textarea
                name="message"
                value={form.message}
                onChange={onChange}
                required
                rows={5}
              />
            </div>
            <p className="contact-note">{t.note}</p>
            <button type="submit" className="contact-btn" disabled={loading}>
              {loading ? '...' : t.send}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
